export var ControlsMode;
(function (ControlsMode) {
    ControlsMode[ControlsMode["Keyboard"] = 0] = "Keyboard";
})(ControlsMode || (ControlsMode = {}));
